import * as t from "io-ts";
import MetricEventTypes from "../../enums/MetricEventTypes";
import { enumCodec, mixed, optional, required } from "../../validation/validator";
import { CallResponseMixinSchema } from "../common/callResponseSchema";

export const TrainingFocusMetricSchema = enumCodec(MetricEventTypes);
export const PerformanceBracketNameSchema = t.keyof({
  "Room to Grow": null,
  Building: null,
  "On Track": null,
  Advanced: null,
  Elite: null,
});

export const GetTrainingFocusRequestSchema = optional({
  recalculate: t.boolean,
});

export const TrainingFocusMetricResultSchema = required({
  bracket: t.union([PerformanceBracketNameSchema, t.null]),
  value: t.union([t.number, t.null]),
});

export const TrainingFocusResultsSchema = required({
  [MetricEventTypes.SCAN_FREQUENCY]: TrainingFocusMetricResultSchema,
  [MetricEventTypes.SCAN_TIMING]: TrainingFocusMetricResultSchema,
  [MetricEventTypes.CRITICAL_SCAN]: TrainingFocusMetricResultSchema,
  [MetricEventTypes.AWARENESS]: TrainingFocusMetricResultSchema,
  [MetricEventTypes.DECISION]: TrainingFocusMetricResultSchema,
});

export const TrainingFocusSchema = mixed([
  required({
    metric: TrainingFocusMetricSchema,
    created_at: t.string,
  }),
  optional({
    results: TrainingFocusResultsSchema,
  }),
]);

export const GetTrainingFocusResponseSchema = mixed([
  required({
    data: t.union([TrainingFocusSchema, t.null]),
  }),
  CallResponseMixinSchema,
]);

export type TrainingFocus = t.TypeOf<typeof TrainingFocusSchema>;
export type TrainingFocusResults = t.TypeOf<typeof TrainingFocusResultsSchema>;
export type PerformanceBracketName = t.TypeOf<typeof PerformanceBracketNameSchema>;

export const GetUserProgressionResponseSchema = required({
  user_rating: t.number,
  previous_user_rating: t.number,
  progression_config: required({ leagues: t.array(t.any) }),
});

export type UserProgression = t.TypeOf<typeof GetUserProgressionResponseSchema>;

export const ProgressionApis = {
  Progression: {
    GetUserProgression: {
      Name: "progression-getUserProgression",
      Request: required({ user_id: t.union([t.number, t.null]) }),
      Response: GetUserProgressionResponseSchema,
    },
    GetTrainingFocus: {
      Name: "progression-getTrainingFocus",
      Request: GetTrainingFocusRequestSchema,
      Response: GetTrainingFocusResponseSchema,
    },
  },
};
